import classNames from 'classnames'
import { useEffect, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { EnumHelperText, HelperText, toastStore } from 'shared/ui'
import { MessageField } from 'widgets/MessageField'
import { AgentActionNoteStore } from '../store/agentActionNoteStore'
import { type IAgentActionContentProps } from '../types/types'

import styles from './styles.module.scss'

export const ActionNote = observer(({ control, error, onErrorReset }: IAgentActionContentProps) => {
  const isDirty = useRef(false)

  useEffect(() => {
    if (!(control instanceof AgentActionNoteStore)) return
    if (isDirty.current) onErrorReset()
    isDirty.current = true
  }, [control instanceof AgentActionNoteStore ? control.note.messageText : null])

  useEffect(() => {
    if (!(control instanceof AgentActionNoteStore)) return
    if (isDirty.current && control.note.textLimitReached)
      toastStore.add({
        title: control.note.textLimit.message,
        type: 'error',
      })
  }, [control instanceof AgentActionNoteStore ? control.note.textLimitReached : null])

  useEffect(() => {
    if (control instanceof AgentActionNoteStore) control.syncNote()
  }, [])

  if (!(control instanceof AgentActionNoteStore)) return null

  return (
    <div className={styles.message}>
      <div className={classNames(styles.field, { [styles.fieldError]: !!error })}>
        <MessageField messageFieldStore={control.note} />
      </div>
      {!!error && (
        <HelperText icon={'alertTriangleSmall'} variant={EnumHelperText.Error} text={error} />
      )}
    </div>
  )
})
